module.exports = __webpack_public_path__ + "static/media/gonzalo-remy-JCIJnIXv7SE-unsplash.9742ebc8.jpg";